import { convoyFactory } from '@rtls/core/models/convoy/convoy.factory';
import { DelaySummary } from '@rtls/core/models/convoy/delay-summary.model';
import { delayFactory } from '@rtls/core/models/convoy/delay.factory';
import { randomList, randomNumber } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const delaySummaryFactory = Factory.makeFactory<DelaySummary>({
	id: Factory.each(() => randomNumber()),
	convoy: Factory.each(() => convoyFactory.build()),
	delays: Factory.each(() => randomList(() => delayFactory.build(), 1)),
});
